/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TeamsInputs */

const th_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีม`)
};

const en_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ja_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム`)
};

const zh_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球队`)
};

const es_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipos`)
};

const pt_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Times`)
};

const id_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim`)
};

const fr_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipes`)
};

const tl_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga team`)
};

const vi_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội`)
};

const ko_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀`)
};

const de_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const ru_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команды`)
};

const tr_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımlar`)
};

const it_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadre`)
};

const pl_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drużyny`)
};

const uk_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команди`)
};

const hi_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीमें`)
};

const ar_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفرق`)
};

const ms_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan`)
};

const bn_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল`)
};

const zh_tw2_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const zh_hk2_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊`)
};

const ur_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیمیں`)
};

const fa_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم‌ها`)
};

const sw_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu`)
};

const nl_nav_teams = /** @type {(inputs: Nav_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Nav_TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const nav_teams = /** @type {((inputs?: Nav_TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_nav_teams(inputs)
	if (locale === "ja") return ja_nav_teams(inputs)
	if (locale === "zh") return zh_nav_teams(inputs)
	if (locale === "es") return es_nav_teams(inputs)
	if (locale === "pt") return pt_nav_teams(inputs)
	if (locale === "id") return id_nav_teams(inputs)
	if (locale === "fr") return fr_nav_teams(inputs)
	if (locale === "tl") return tl_nav_teams(inputs)
	if (locale === "vi") return vi_nav_teams(inputs)
	if (locale === "ko") return ko_nav_teams(inputs)
	if (locale === "de") return de_nav_teams(inputs)
	if (locale === "ru") return ru_nav_teams(inputs)
	if (locale === "tr") return tr_nav_teams(inputs)
	if (locale === "it") return it_nav_teams(inputs)
	if (locale === "pl") return pl_nav_teams(inputs)
	if (locale === "uk") return uk_nav_teams(inputs)
	if (locale === "hi") return hi_nav_teams(inputs)
	if (locale === "ar") return ar_nav_teams(inputs)
	if (locale === "ms") return ms_nav_teams(inputs)
	if (locale === "bn") return bn_nav_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_nav_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_nav_teams(inputs)
	if (locale === "ur") return ur_nav_teams(inputs)
	if (locale === "fa") return fa_nav_teams(inputs)
	if (locale === "sw") return sw_nav_teams(inputs)
	if (locale === "nl") return nl_nav_teams(inputs)
	return en_nav_teams(inputs)
});